import moment from 'moment';

export function changeRequiredOptionsFields(filterData) {
    const isTypeProtocol = filterData.type.value === 'perProtocol';

    return {
        ...filterData,
        protocol: { ...filterData.protocol, required: isTypeProtocol },
        period: {
            ...filterData.period,
            required: !isTypeProtocol || (isTypeProtocol && filterData.operationType.value),
        },
    };
}

export function getPayload(filterData, contractNumber) {
    let [startDate, endDate] = filterData.period?.value || [];

    if (startDate && endDate) {
        startDate = moment(startDate).format('DD/MM/YYYY');
        endDate = moment(endDate).format('DD/MM/YYYY');
    }

    let queryParams = {
        offset: 0,
        limit: 1000,
        dataInicioPeriodo: startDate,
        dataFimPeriodo: endDate,
        numeroContrato: filterData.contract.value || contractNumber,
    };

    switch (filterData.type.value) {
        case 'perOperation':
            queryParams = {
                ...queryParams,
                codigoTipoOperacao: filterData.operationType.value,
                status: filterData.status.value,
            };
            break;
        case 'perProtocol':
            queryParams = {
                ...queryParams,
                numeroSequencialLote: filterData.protocol.value,
                codigoTipoOperacao: filterData.operationType.value,
                status: filterData.status.value,
            };
            break;
        default:
            queryParams = {
                ...queryParams,
                chaveBusca: filterData.identity.value,
            };
            break;
    }

    return queryParams;
}
